<div class="dealer-preferred-dealer modal-body-cit2" oxDrawerModal>
  <div class="row">
    <div class="col-12">

      <!-- HEADER -->
      <div class="row">
        <div class="col-12">
          <div class="{{language}} d-flex">
            <div class="gb-headline1" role="heading" aria-level="1">
              <span aria-hidden="true" class="icon-graphic-star"></span>&nbsp;
              <span [translate]="'preferredDealer_title'"></span>
            </div>
            <button class="close-modal {{language}} ml-auto" dismiss="modal" (click)="modalRef.hide();"
                    aria-hidden="false" attr.aria-label="{{'aoda_close_modal_label' | translate}}">
              <span aria-hidden="true" class="icon-ui-closedot gb-body1"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="page-header-subinfo">
            <ul class="list-inline">
              <li class="gb-body1" *ngIf="displayMode === 'dealerInfo'" 
                  [trackLink]="'PreferredDealer:FindAnotherDealer'"
                  [trackDelay]="'true'"
                  [trackType]="'o'"
                  [prop10]="'preferred dealer:link:find another dealer'">
                <a class="m-2"
                   (click)="findADealer(); modalRef.hide()"
                   [translate]="'preferredDealer_findAnotherDealer'">
                </a>
              </li>
              <li class="gb-body1" *ngIf="displayMode === 'directions'" >
                <a class="m-2"
                   (click)="hideDirections()"
                   [translate]="'preferredDealer_closeDirections'">
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- LOADING IMAGE -->
      <ox-loading *ngIf="displayMode === 'loading'"></ox-loading>
      <!-- END LOADING IMAGE -->

      <!-- VIEW DEALERSHIP INFORMATION -->
      <div *ngIf="displayMode === 'dealerInfo'">
        <webu-dealer-info
          [dealer]="preferredDealer"
          [cmsPrefix]="'locateDealer'"
          [trackLinkPrefix]="'Locate Dealer'"
          [prop10Prefix]="'locate dealer'"
          (viewDirectionsChange)="showDirections($event)">
        </webu-dealer-info>
      </div>
      <!-- END VIEW DEALERSHIP INFORMATION -->

      <!-- DIRECTIONS -->
      <div class="row" *ngIf="displayMode === 'directions'">
        <div class="col-12">
          <webu-dealer-directions [profileAddress]="profileAddress" [dealer]="preferredDealer"></webu-dealer-directions>
        </div>
      </div>
      <!-- END DIRECTIONS -->

      <!-- CANNOT LOAD PREFERRED DEALER -->
      <div class="row" >
        <div class="col-12">
          <p class="oc-alert-error" *ngIf="displayMode === 'cannotLoad'">
            <span aria-atomic="true" role="alert" [translate]="'preferredDealer_cannotLoad'"></span>
          </p>
        </div>
      </div>
      <!-- END CANNOT LOAD PREFERRED DEALER -->

    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="modal-footer-content"></div>
</div>